import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";
import Modal from "@mui/material/Modal";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import success from "../../Assets/Images/successImg.png";
import downloadLottie from "../../Assets/Animations/downloadProgress.json";
import download from "../../Assets/Images/downloadBanner.png";

import { useTranslation } from "react-i18next";
import "../../Assets/Styles/pages/uploadImage.scss";
import helper_functions from "../../Config/helper_functions";
import { setClean, setCreate } from "../../Redux/DownloadSlice/downloadSlice";
import { piexif } from "piexifjs";
import { ClearImage } from "../../Redux/MainImage/imageSlice";
import { deleteAll } from "../../Redux/WaterMarks/wateramarks";
import LottiePlayer from "../LottiePlayer/lottiePlayer";

const DownloadImageProgress = ({ open, setOpenProgress, setOpen }) => {
  const [image, setImage] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const { t } = useTranslation();

  const downloadState = useSelector((state) => state["downloadSlice"]);
  const mainImage = useSelector((state) => state["mainImage"]);

  const dispatch = useDispatch();

  useEffect(() => {
    setOpen(false);
    if (image && open) dispatch(setCreate(1));

    return () => {
      setImage(false);
      dispatch(setCreate(0));
      dispatch(setClean());
    };
  }, [image]);

  useEffect(() => {
    if (downloadState.readyTodownload) {
      downloadImage();
    }
  }, [downloadState.readyTodownload, downloadState.Image]);
  const downloadImage = async () => {
    var width, height;

    if (downloadState.Resolution) {
      width = downloadState.Resolution;
      // Calculate height to maintain aspect ratio
      height =
        (downloadState.Resolution / downloadState.mainImageWidth) *
        downloadState.mainImageHeight;
    } else {
      width = downloadState.mainImageWidth;
      height = downloadState.mainImageHeight;
    }

    var img = await helper_functions.resizeFile(
      downloadState.Image,
      width,
      height,
      downloadState.Format ? downloadState.Format : downloadState.Extension,
      downloadState.Quality
    );

    var name =
        "image." +
        (downloadState.Format ? downloadState.Format : downloadState.Extension),
      uri = img;
    var metadataString;
    try {
      metadataString = JSON.parse(mainImage.metadata);
      var exifbytes = piexif.dump(metadataString);
      uri = piexif.insert(exifbytes, uri);
    } catch (error) {
      console.log("Metadata error: ", error);
    }

    var link = document.createElement("a");
    link.download = name;
    link.href = uri;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    setOpenProgress(false);
    setSuccessModal(true);
  };
  return (
    <>
      {successModal ? (
        <Modal
          open={successModal}
          onClose={() => {
            setSuccessModal(false);
          }}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 800,
          }}
        >
          <Fade in={successModal}>
            <Row className="model downloadProgressModal rounded-4 p-0 m-0">
              <Col className="d-flex flex-column justify-content-center align-items-center rounded-4 p-0">
                <div className="position-relative w-100 p-0 rounded-4">
                  <img
                    alt="success"
                    src={success}
                    className="w-100 rounded roundedBottom_0"
                  />
                </div>
                <Row className="productSansBold mt-5 text_23 mb-1">
                  {t("DownloadImageProgress.SuccessfullyDownloaded")}
                </Row>
                <Row className="productSansLight text_17">
                  {t("DownloadImageProgress.SuccessfullyDownloadedDesc")}
                </Row>
                <Row className="d-flex justify-content-center mt-3 mb-5">
                  <button
                    style={{ background: "#7497AA" }}
                    className="button_text text-light m-0 w_8_rem py-1 mx-2 border-0 d-flex justify-content-center align-items-center button_text_signin"
                    onClick={() => {
                      setSuccessModal(false);
                    }}
                  >
                    Stay There
                  </button>
                  <button
                    style={{ background: "#74AA99" }}
                    className={`button_text text-light m-0 w-auto py-1 px-2 mx-2 border-0 d-flex justify-content-center align-items-center button_text_signin`}
                    onClick={() => {
                      dispatch(ClearImage());
                      dispatch(deleteAll());
                    }}
                  >
                    Watermark Another Image
                  </button>
                  <button
                    style={{ background: "#7497AA" }}
                    className="button_text text-light m-0 w_8_rem py-1 mx-2 border-0 d-flex justify-content-center align-items-center button_text_signin"
                    onClick={async () => {
                      window.location.href = "/";
                    }}
                  >
                    Go to Home
                  </button>
                </Row>
              </Col>
            </Row>
          </Fade>
        </Modal>
      ) : (
        <Modal
          open={open}
          onClose={() => {
            setOpen(false);
          }}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 800,
          }}
        >
          <Fade in={open}>
            <Row className="model downloadProgressModal rounded-4 p-0 m-0">
              <Col className="d-flex flex-column justify-content-center align-items-center rounded-4 p-0">
                <div className="position-relative w-100 p-0 rounded-4">
                  <img
                    alt="download"
                    onLoad={() => setImage(true)}
                    src={download}
                    className="w-100 rounded roundedBottom_0"
                  />
                  <div className="downloadAnimation">
                    <LottiePlayer src={downloadLottie} />
                  </div>
                </div>
                <Row className="productSansBold mt-5 text_23 mb-1">
                  {t("DownloadImageProgress.Downloading")}
                </Row>
                <Row className="productSansLight text_17 mb-5">
                  {t("DownloadImageProgress.Wait")}
                </Row>
              </Col>
            </Row>
          </Fade>
        </Modal>
      )}
    </>
  );
};

export default DownloadImageProgress;
